<iu-multi-level-autocomplete-ui
  [groups]="suggestions | async"
  [value]="tags"
  (selectionChanged)="onSelectionChanged($event)"
  [placeholder]="'tagsEditor.placeholder' | translate"
  #autocomplete />
